/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { CommonSandbox } from '../../common/common.sandbox';
import {CommonService} from '../../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sandbox: CommonSandbox
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> | boolean {
    this.sandbox.doSettings();
    setTimeout(() => {}, 5000);
    if (localStorage.getItem('vendor-settings') && JSON.parse(localStorage.getItem('vendor-settings'))?.maintenanceMode == 1) { 
      this.router.navigate(['/maintenance']);
      return false;
    }
    else { return this.checkLogin(state.url, route); }
  }
  // CheckLogin
  checkLogin(url: string, route: any): Promise<boolean> | boolean {
    let lastPath: any;
    if (route.url && route.url.length > 0 && route.url[0].path) {
      lastPath = route.url[0].path;
    }
    let currentUser: any;
    currentUser = localStorage.getItem('vendorToken');


    if (currentUser) {
      if (url === '/auth/login' || url === '/auth' || url === '/auth/recover-password' || lastPath === 'set-password') {
        // Navigate to the login page with extras
        this.router.navigate(['/dashboard']);
        return false;
      }
      return true;
    } else {
      if (url === '/auth/login' || url === '/auth' || url === '/auth/recover-password' || url.includes('/auth/set-password')) {
        return true;
      } else {
        this.router.navigate(['/auth/login']);
      }
    }
    // Navigate to the login page with extras
    this.router.navigate(['/auth/login']);
    return false;
  }
}
